export type TreeRow<N> = { node: N; depth: number }

export function openTreeRows<N extends { children: N[] }>(
  nodes: N[],
  isOpen: (node: N) => boolean,
): TreeRow<N>[] {
  const rows: TreeRow<N>[] = []
  const visit = (level: N[], depth: number) => {
    for (const node of level) {
      rows.push({ node, depth })
      if (node.children.length > 0 && isOpen(node)) visit(node.children, depth + 1)
    }
  }
  visit(nodes, 0)
  return rows
}
